import {
  // eslint-disable-next-line import/named
  DELIVERY_STEP, LOADING_STEP, SERVICE_STEP, INVENTORY_STEP, CREATED_STEP,
} from '@/store/modules/projectStore';

export default class RouteManager {
  static parentRoutes = [
    'loading',
    'delivery',
    'serviceOffer',
    'furnitures',
    'validate',
  ]

  static routes = [
    /* eslint-disable object-curly-newline */
    { name: 'loadingAddress', next: 1, previous: null, newStep: CREATED_STEP },
    { name: 'loadingHousing', next: 2, previous: 0 },
    { name: 'loadingFurnitureTransport', next: 3, previous: 1 },
    { name: 'loadingParkingArea', next: 4, previous: 2 },
    { name: 'deliveryAddress', next: 5, previous: 3, newStep: LOADING_STEP },
    { name: 'deliveryHousing', next: 6, previous: 4 },
    { name: 'deliveryFurnitureTransport', next: 7, previous: 5 },
    { name: 'deliveryParkingArea', next: 8, previous: 6 },
    { name: 'serviceOfferDates', next: 9, previous: 7, newStep: DELIVERY_STEP },
    { name: 'serviceOfferServices', next: 10, previous: 8 },
    { name: 'serviceOfferAssurance', next: 11, previous: 9 },
    { name: 'furnituresRooms', next: 12, previous: 10, newStep: SERVICE_STEP },
    { name: 'furnituresInventory', next: 13, previous: 11 },
    { name: 'furnituresBoxConfig', next: 14, previous: 12 },
    { name: 'furnituresBoxDelivery', next: 15, previous: 13 },
    { name: 'validateConfirm', next: 16, previous: 14, newStep: INVENTORY_STEP, sync: true },
    { name: 'validateDone', next: null, previous: null },
  ]

  static next(name) {
    const currentRoute = this.getCurrentRoute(name);
    if (currentRoute !== null && currentRoute.next !== null) {
      return this.routes[currentRoute.next];
    }
    return null;
  }

  static previous(name) {
    const currentRoute = this.getCurrentRoute(name);
    if (currentRoute !== null && currentRoute.previous !== null) {
      return this.routes[currentRoute.previous];
    }
    return null;
  }

  static getCurrentRoute(name) {
    for (const route of this.routes) {
      if (route.name === name) return route;
    }
    return null;
  }

  static getCurrentRouteIndex(name) {
    const index = this.routes.findIndex(route => route.name === name);
    if (index === -1) return 0;
    return index;
  }

  static getBaseStepRoute(name) {
    let route = this.getCurrentRoute(name);
    while (route && !route.newStep) {
      route = this.routes[route.previous];
    }
    return route && route.newStep;
  }

  static getNbRoute() {
    return this.routes.length;
  }

  static getRouteComposition(name) {
    for (const parent of this.parentRoutes) {
      if (name && name.startsWith(parent)) {
        const childRoute = name.substr(parent.length);
        return {
          parentRoute: parent,
          childRoute: childRoute.charAt(0).toLowerCase() + childRoute.slice(1),
        };
      }
    }
    return null;
  }
}
